export default "Plan Pluriannuel de Travaux (PPT) — Copropriétés | Solution Éco France";
